document.addEventListener('DOMContentLoaded', () => {
    const nav = document.querySelector('.jump-to-section');

    if (!nav) return;

    const headings = document.querySelectorAll(
        '.page-layout__body .video-embed h2'
    );

    if (!headings.length) return;

    const listToggleButton = document.querySelector('.all-content-link');
    const iconOpen = document.querySelector('.jump-to-section .icon-open');
    const iconClose = document.querySelector('.jump-to-section .icon-close');
    const linkListMain = document.querySelector('.jump-to-list');
    const linkListInner = document.querySelector('.jump-to-list--inner');
    const title = document.querySelector('.jump-to-title');
    const contentWrapper = document.querySelector('.jump-to-content-wrapper');
    const numberOfLinksToDisplay = Number.isNaN(nav.dataset.visibleLinks)
        ? '4'
        : nav.dataset.visibleLinks;

    for (let i = 0; i < headings.length; i++) {
        const listElement = document.createElement('li');
        const listElementContent = document.createTextNode(
            headings[i].innerText
        );
        listElement.appendChild(listElementContent);
        listElement.addEventListener('click', () => {
            headings[i].scrollIntoView();
            contentWrapper.classList.add('hidden');
            title
                .querySelector('svg')
                .classList.remove('jump-to-chevron--opened');
        });

        if (i < numberOfLinksToDisplay) {
            linkListMain.appendChild(listElement);
        } else {
            linkListInner.appendChild(listElement);
        }
    }

    if (headings.length <= numberOfLinksToDisplay)
        document.querySelector('.all-content-wrapper').classList.add('hidden');

    listToggleButton.addEventListener('click', () => {
        linkListInner.classList.toggle('jump-to-list--opened');
        iconOpen.classList.toggle('hidden');
        iconClose.classList.toggle('hidden');
    });

    title.addEventListener('click', () => {
        contentWrapper.classList.toggle('hidden');
        title.querySelector('svg').classList.toggle('jump-to-chevron--opened');
    });
});
